import React from 'react';
import { DropdownButton, MenuItem } from 'ui';

const PLACEHOLDER = 'Select transcript to export';

// Scoped styles: a select-box trigger and a
// menu with a bold header row, spacious items, and a soft shadow.
// The trigger renders inside .transcript-select-dropdown; the menu portals
// to the document root, so it gets its own class via menuClassName.
const DROPDOWN_STYLE = `
  .transcript-select-dropdown .ui-btn,
  .transcript-select-dropdown .ui-btn:hover,
  .transcript-select-dropdown .ui-btn:focus,
  .transcript-select-dropdown .ui-btn:active {
    background: #fff;
    border: 1px solid #d0d0d0;
    border-radius: 6px;
    padding: 8px 16px;
    font-size: 15px;
    min-width: 240px;
    text-align: left;
    color: #222;
    box-shadow: none;
  }
  .transcript-select-menu {
    min-width: 240px;
    max-height: 320px;
    overflow-y: auto;
    padding: 0;
    border: 1px solid #d0d0d0;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
  .transcript-select-menu .ui-menu__header {
    padding: 10px 16px;
    font-weight: 600;
    font-size: 14px;
    color: #222;
    border-bottom: 1px solid #eee;
  }
  .transcript-select-menu .ui-menu__item {
    padding: 10px 16px;
    font-size: 15px;
    color: #222;
    white-space: normal;
  }
  .transcript-select-menu .ui-menu__item:hover,
  .transcript-select-menu .ui-menu__item:focus,
  .transcript-select-menu .ui-menu__item[data-highlighted] {
    background: #f5f5f5;
    color: #222;
  }
  .transcript-select-menu .ui-menu__item.active,
  .transcript-select-menu .ui-menu__item.active:hover,
  .transcript-select-menu .ui-menu__item.active:focus {
    background: #e5e5e5;
    color: #222;
  }
`;

const TranscriptSelectDropdown = ({ transcripts, value, onChange }) => {
  const selected = transcripts.find((t) => t.id === value);

  return (
    <div className="transcript-select-dropdown" style={{ display: 'inline-block' }}>
      <style>{DROPDOWN_STYLE}</style>
      <DropdownButton
        id="transcript-select-dropdown"
        variant="white"
        noCaret
        menuClassName="transcript-select-menu"
        title={selected ? selected.name : PLACEHOLDER}
      >
        <MenuItem header>{PLACEHOLDER}</MenuItem>
        {transcripts.length === 0 && (
          <MenuItem disabled>No transcripts</MenuItem>
        )}
        {transcripts.map((t) => (
          <MenuItem
            key={t.id}
            active={t.id === value}
            onClick={() => onChange(t.id)}
          >
            {t.name}
          </MenuItem>
        ))}
      </DropdownButton>
    </div>
  );
};

export default TranscriptSelectDropdown;
